// import { useState } from "react";
// import emailjs from "emailjs-com";
import React from "react";
import { LaptopIcon } from "../icons/LaptopIcon";

// const initialState = {
//   name: "",
//   email: "",
//   message: "",
// };
export const Contact = (props) => {
  // const [{ name, email, message }, setState] = useState(initialState);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setState((prevState) => ({ ...prevState, [name]: value }));
  // };
  // const clearState = () => setState({ ...initialState });

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log(name, email, message);

  //   {
  //     /* replace below with your own Service ID, Template ID and Public Key from your EmailJS account */
  //   }

  //   emailjs
  //     .sendForm(
  //       "YOUR_SERVICE_ID",
  //       "YOUR_TEMPLATE_ID",
  //       e.target,
  //       "YOUR_PUBLIC_KEY"
  //     )
  //     .then(
  //       (result) => {
  //         console.log(result.text);
  //         clearState();
  //       },
  //       (error) => {
  //         console.log(error.text);
  //       }
  //     );
  // };

  return (
    <div id="contact">
      <div className="container">
        <div className="section-title text-center">
          <h2>Get In Touch</h2>
          <p>
            Ready to start your next project? We're here to help you achieve your goals.
            Our team of experts is available to discuss your requirements and provide
            tailored solutions for your business needs.
          </p>
        </div>
        <div className="row contact-row">
          <div className="col-md-4">
            <div className="contact-info">
              <h3>Contact Information</h3>
              <p>
                We're committed to providing exceptional service and support to our clients.
                Feel free to reach out to us through any of the following channels.
              </p>
              <div className="working-hours">
                Working Hours: 9AM - 9PM Daily
              </div>
              <div className="contact-item">
                <i className="fa fa-map-marker"></i>
                <p>Uhorska 12, Lviv, Ukraine</p>
              </div>
              <div className="contact-item">
                <i className="fa fa-phone"></i>
                <p>+380 (73) 553 22 51</p>
              </div>
              <div className="contact-item">
                <i className="fa fa-envelope"></i>
                <p>error.software.ua@gmail.com</p>
              </div>
            </div>
          </div>
          {/* <div className="col-md-8">
            <form name="sentMessage" id="contactForm" noValidate>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-control"
                      placeholder="Name"
                      required
                    />
                    <p className="help-block text-danger"></p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-control"
                      placeholder="Email"
                      required
                    />
                    <p className="help-block text-danger"></p>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  className="form-control"
                  placeholder="Subject"
                  required
                />
                <p className="help-block text-danger"></p>
              </div>
              <div className="form-group">
                <textarea
                  name="message"
                  id="message"
                  className="form-control"
                  rows="4"
                  placeholder="Message"
                  required
                ></textarea>
                <p className="help-block text-danger"></p>
              </div>
              <div id="success"></div>
              <button type="submit" className="btn btn-custom btn-lg">
                Send Message
              </button>
            </form>
          </div> */}
        </div>
        <div className="social">
          <ul>
            <li>
              <a href="#">
                <i className="fa fa-facebook"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-twitter"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-linkedin"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-instagram"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
